export enum LayerType {
    DEFAULT = 0,
    RAYCAST = 1
}
